import { RoleOnboardingConfig } from '../../types/onboarding';
import {
  DEMO_APP_ICON,
  DEMO_APP_DESCRIPTION,
  demoVersions,
  createDemoDataForUser,
  getDemoAppNameForRole
} from './demoData';

/**

  // Різні набори подій для різних макетів
  const screenEvents: Record<string, DemoEvent[]> = {
    // Версія 1.0 - Екран входу (2 події)
    'v1-login': [
      {
        id: `${baseId}-e1`,
        title: 'screen_view_login',
        description: 'Перегляд екрану входу користувачем',
        type: 'view',
        status: 'implemented',
        coordinates: { x: 50, y: 20 },
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 10 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'screen_name', value: 'login', type: 'string' },
          { key: 'user_type', value: 'returning', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e2`,
        title: 'login_button_tap',
        description: 'Натискання кнопки входу',
        type: 'click',
        status: 'implemented',
        coordinates: { x: 50, y: 65 },
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 9 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'button_id', value: 'btn_login', type: 'string' },
          { key: 'auth_method', value: 'email', type: 'string' }
        ]
      }
    ],
    // Версія 1.0 - Головний екран (7 подій)
    'v1-home': [
      {
        id: `${baseId}-e1`,
        title: 'home_screen_view',
        description: 'Перегляд головного екрану',
        type: 'view',
        status: 'implemented',
        coordinates: { x: 50, y: 15 },
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 10 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'screen_name', value: 'home', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e2`,
        title: 'search_tap',
        description: 'Натискання на пошук',
        type: 'click',
        status: 'new',
        coordinates: { x: 85, y: 8 },
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'search_location', value: 'header', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e3`,
        title: 'category_card_swipe',
        description: 'Прокрутка категорій',
        type: 'custom',
        status: 'edited',
        coordinates: { x: 50, y: 35 },
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'direction', value: 'horizontal', type: 'string' },
          { key: 'items_count', value: 8, type: 'number' }
        ],
        comments: [
          {
            id: 'c1',
            text: 'Додати відстеження швидкості свайпу',
            author: 'demo-analyst',
            createdAt: new Date(now.getTime() - 4 * 24 * 60 * 60 * 1000).toISOString()
          }
        ]
      },
      {
        id: `${baseId}-e4`,
        title: 'promo_banner_view',
        description: 'Перегляд промо-банеру',
        type: 'view',
        status: 'implemented',
        coordinates: { x: 50, y: 55 },
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 8 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'banner_id', value: 'promo_spring_2026', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e5`,
        title: 'product_card_tap',
        description: 'Натискання на картку товару',
        type: 'click',
        status: 'new',
        coordinates: { x: 25, y: 75 },
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'product_id', value: 'prod_12345', type: 'string' },
          { key: 'position', value: 1, type: 'number' }
        ]
      },
      {
        id: `${baseId}-e6`,
        title: 'old_quick_filter',
        description: 'Застарілий фільтр (більше не використовується)',
        type: 'custom',
        status: 'deleted',
        coordinates: { x: 15, y: 92 },
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 20 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'filter_type', value: 'legacy', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e7`,
        title: 'bottom_nav_home',
        description: 'Навігація через нижнє меню - Головна',
        type: 'click',
        status: 'implemented',
        coordinates: { x: 15, y: 97 },
        createdBy: 'demo-developer',
        createdAt: new Date(now.getTime() - 10 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'tab_name', value: 'home', type: 'string' }
        ]
      }
    ],
    // Версія 2.0 - Екран входу (14 подій з усіма статусами)
    // Реальне розташування на макеті: логотип → поле login → поле password → кнопка → forgot → соцкнопки
    'v2-login': [
      {
        id: `${baseId}-e1`,
        title: 'screen_view_login',
        description: 'Перегляд екрану входу користувачем',
        type: 'view',
        status: 'implemented',
        coordinates: { x: 50, y: 20 },  // Логотип Figma зверху
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 10 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'screen_name', value: 'login', type: 'string' },
          { key: 'user_type', value: 'returning', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e2`,
        title: 'login_button_tap',
        description: 'Натискання кнопки входу',
        type: 'click',
        status: 'implemented',
        coordinates: { x: 50, y: 65 },  // Кнопка "Log in" по центру
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 9 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'button_id', value: 'btn_login', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e3`,
        title: 'biometric_auth_prompt',
        description: 'Запит на біометричну автентифікацію (новий у V2)',
        type: 'custom',
        status: 'new',
        coordinates: { x: 35, y: 80 },  // Ліва кнопка (Google)
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'auth_type', value: 'face_id', type: 'string' },
          { key: 'supported', value: true, type: 'boolean' }
        ]
      },
      {
        id: `${baseId}-e4`,
        title: 'forgot_password_tap',
        description: 'Натискання "Забули пароль?"',
        type: 'click',
        status: 'edited',
        coordinates: { x: 50, y: 72 },  // Під кнопкою "Forgot Password?"
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'recovery_method', value: 'email', type: 'string' }
        ],
        comments: [
          {
            id: 'c1',
            text: 'Додати відстеження успішності відправки',
            author: 'demo-analyst',
            createdAt: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString()
          }
        ]
      },
      {
        id: `${baseId}-e5`,
        title: 'social_login_google',
        description: 'Вхід через Google (новий у V2)',
        type: 'click',
        status: 'new',
        coordinates: { x: 30, y: 85 },  // Ліва соціальна кнопка знизу
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'provider', value: 'google', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e6`,
        title: 'social_login_apple',
        description: 'Вхід через Apple (новий у V2)',
        type: 'click',
        status: 'new',
        coordinates: { x: 70, y: 85 },  // Права соціальна кнопка знизу
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'provider', value: 'apple', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e7`,
        title: 'legacy_email_input',
        description: 'Старе поле email (замінено на нове)',
        type: 'input',
        status: 'pending_deletion',
        coordinates: { x: 50, y: 40 },  // Поле "Log in" ліворуч
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'field_type', value: 'email_legacy', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e8`,
        title: 'old_guest_mode',
        description: 'Режим гостя (видалено у V2)',
        type: 'click',
        status: 'deleted',
        coordinates: { x: 25, y: 75 },  // Ліва кнопка над "Forgot"
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 25 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'mode', value: 'guest', type: 'string' }
        ]
      },
      // Додаткові події для демо туру
      {
        id: `${baseId}-e9`,
        title: 'new_email_validation',
        description: 'Валідація email (нова подія)',
        type: 'success',
        status: 'new',
        coordinates: { x: 50, y: 38 },  // Над полем "Log in"
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 12 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'validation_type', value: 'email_format', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e10`,
        title: 'password_strength_check',
        description: 'Перевірка складності пароля (редагована)',
        type: 'custom',
        status: 'edited',
        coordinates: { x: 50, y: 52 },  // Поле "Password" праворуч
        createdBy: 'demo-developer',
        createdAt: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'min_length', value: 8, type: 'number' },
          { key: 'require_special', value: true, type: 'boolean' }
        ],
        comments: [
          {
            id: 'c2',
            text: 'Оновити вимоги до пароля - додати спецсимволи',
            author: 'demo-analyst',
            createdAt: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString()
          }
        ]
      },
      {
        id: `${baseId}-e11`,
        title: 'login_error_invalid_credentials',
        description: 'Помилка входу - невірні дані (впроваджена)',
        type: 'error',
        status: 'implemented',
        coordinates: { x: 50, y: 58 },  // Помилка між полем і кнопкою
        createdBy: 'demo-developer',
        createdAt: new Date(now.getTime() - 8 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'error_code', value: 'AUTH_001', type: 'string' },
          { key: 'retry_allowed', value: true, type: 'boolean' }
        ]
      },
      {
        id: `${baseId}-e12`,
        title: 'old_phone_login',
        description: 'Вхід за телефоном (застарілий метод)',
        type: 'click',
        status: 'pending_deletion',
        coordinates: { x: 75, y: 75 },  // Кнопка праворуч від guest mode
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 20 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'method', value: 'phone_legacy', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e13`,
        title: 'legacy_captcha_verify',
        description: 'Captcha верифікація (видалена)',
        type: 'success',
        status: 'deleted',
        coordinates: { x: 85, y: 10 },  // Верхній правий кут екрану
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'provider', value: 'recaptcha_v2', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e14`,
        title: 'remember_me_toggle',
        description: 'Перемикач "Запам\'ятати мене" (новий)',
        type: 'click',
        status: 'new',
        coordinates: { x: 50, y: 62 },  // Галочка "Remember me" над кнопкою
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 6 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'default_value', value: false, type: 'boolean' },
          { key: 'persist_days', value: 30, type: 'number' }
        ]
      }
    ],
    // Версія 2.0 - Головний екран (9 подій)
    // Реальне розташування: пошук → категорії → картки → нижнє меню
    'v2-home': [
      {
        id: `${baseId}-e1`,
        title: 'home_screen_view',
        description: 'Перегляд головного екрану',
        type: 'view',
        status: 'implemented',
        coordinates: { x: 50, y: 10 },  // Заголовок "Home"
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 10 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'screen_name', value: 'home', type: 'string' },
          { key: 'version', value: 'v2', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e2`,
        title: 'search_tap',
        description: 'Натискання на пошук',
        type: 'click',
        status: 'implemented',
        coordinates: { x: 50, y: 18 },  // Поле пошуку
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'search_location', value: 'header_v2', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e3`,
        title: 'smart_search_ai',
        description: 'AI-пошук (новий у V2)',
        type: 'custom',
        status: 'new',
        coordinates: { x: 30, y: 28 },  // Ліва категорія (Favorites)
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'ai_enabled', value: true, type: 'boolean' },
          { key: 'suggestions_count', value: 5, type: 'number' }
        ]
      },
      {
        id: `${baseId}-e4`,
        title: 'category_card_swipe',
        description: 'Прокрутка категорій',
        type: 'custom',
        status: 'implemented',
        coordinates: { x: 50, y: 35 },  // Категорії по центру
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 6 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'direction', value: 'horizontal', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e5`,
        title: 'promo_banner_view',
        description: 'Перегляд промо-банеру',
        type: 'view',
        status: 'implemented',
        coordinates: { x: 50, y: 48 },  // Банер по центру
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 4 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'banner_id', value: 'promo_spring_v2', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e6`,
        title: 'product_card_tap',
        description: 'Натискання на картку товару',
        type: 'click',
        status: 'implemented',
        coordinates: { x: 30, y: 65 },  // Ліва картка товару
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'product_id', value: 'prod_12345_v2', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e7`,
        title: 'quick_add_to_cart',
        description: 'Швидке додавання в кошик (новий у V2)',
        type: 'click',
        status: 'new',
        coordinates: { x: 70, y: 65 },  // Права картка з кнопкою
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'action', value: 'quick_add', type: 'string' },
          { key: 'animation', value: 'fly_to_cart', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e8`,
        title: 'old_recommendations',
        description: 'Старі рекомендації (замінено AI)',
        type: 'view',
        status: 'pending_deletion',
        coordinates: { x: 25, y: 82 },  // Нижня ліва картка
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 20 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'type', value: 'legacy', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e9`,
        title: 'removed_banner_slider',
        description: 'Слайдер банерів (видалено)',
        type: 'custom',
        status: 'deleted',
        coordinates: { x: 75, y: 82 },  // Нижня права картка
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'component', value: 'banner_slider', type: 'string' }
        ]
      }
    ],
    // Версія 2.0 - Профіль (9 подій)
    // Реальне розташування: аватар → ім'я → поля → перемикачі → кнопки
    'v2-profile': [
      {
        id: `${baseId}-e1`,
        title: 'profile_screen_view',
        description: 'Перегляд профілю користувача',
        type: 'view',
        status: 'new',
        coordinates: { x: 50, y: 8 },  // Заголовок профілю
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'screen_name', value: 'profile', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e2`,
        title: 'avatar_edit_tap',
        description: 'Натискання для зміни аватару',
        type: 'click',
        status: 'new',
        coordinates: { x: 50, y: 20 },  // Аватар користувача
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'source', value: 'camera', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e3`,
        title: 'name_field_edit',
        description: 'Редагування імені',
        type: 'input',
        status: 'edited',
        coordinates: { x: 50, y: 35 },  // Поле імені (Diana)
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'field', value: 'display_name', type: 'string' }
        ],
        comments: [
          {
            id: 'c1',
            text: 'Додати валідацію на спецсимволи',
            author: 'demo-analyst',
            createdAt: new Date(now.getTime() - 2 * 24 * 60 * 60 * 1000).toISOString()
          },
          {
            id: 'c2',
            text: 'Максимальна довжина 50 символів',
            author: 'demo-developer',
            createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString()
          }
        ]
      },
      {
        id: `${baseId}-e4`,
        title: 'email_change',
        description: 'Зміна email адреси',
        type: 'input',
        status: 'new',
        coordinates: { x: 50, y: 45 },  // Поле Email
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'field', value: 'email', type: 'string' },
          { key: 'verification_required', value: true, type: 'boolean' }
        ]
      },
      {
        id: `${baseId}-e5`,
        title: 'phone_verification',
        description: 'Верифікація телефону',
        type: 'success',
        status: 'implemented',
        coordinates: { x: 50, y: 55 },  // Поле Phone
        createdBy: 'demo-developer',
        createdAt: new Date(now.getTime() - 5 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'method', value: 'sms', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e6`,
        title: 'notifications_toggle',
        description: 'Вмикання/вимикання сповіщень',
        type: 'click',
        status: 'implemented',
        coordinates: { x: 50, y: 65 },  // Перемикач Notifications
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 4 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'enabled', value: true, type: 'boolean' }
        ]
      },
      {
        id: `${baseId}-e7`,
        title: 'privacy_settings_open',
        description: 'Відкриття налаштувань приватності',
        type: 'click',
        status: 'new',
        coordinates: { x: 50, y: 75 },  // Перемикач Privacy
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'section', value: 'privacy', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e8`,
        title: 'old_language_selector',
        description: 'Старий вибір мови (перенесено в налаштування)',
        type: 'click',
        status: 'pending_deletion',
        coordinates: { x: 80, y: 88 },  // Кнопка Log out праворуч
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'location', value: 'main_profile', type: 'string' }
        ]
      },
      {
        id: `${baseId}-e9`,
        title: 'legacy_favorites',
        description: 'Старий розділ обраного (видалено)',
        type: 'view',
        status: 'deleted',
        coordinates: { x: 20, y: 88 },  // Кнопка Edit Profile ліворуч
        createdBy: 'demo-analyst',
        createdAt: new Date(now.getTime() - 25 * 24 * 60 * 60 * 1000).toISOString(),
        params: [
          { key: 'feature', value: 'legacy_fav', type: 'string' }
        ]
      }
    ]
  };

  const key = `${version}-${screenId}`;
  return screenEvents[key] || [];
}

/**
 * Конфигурация онбординга для Viewer
 * Той самий ShopApp Demo проєкт, але з фокусом на перегляд даних
 */
export const viewerOnboardingConfig: RoleOnboardingConfig = {
  role: 'viewer',
  demoAppName: getDemoAppNameForRole('viewer'),
  demoAppIcon: DEMO_APP_ICON,
  demoAppDescription: DEMO_APP_DESCRIPTION,

  steps: [
    // === БЛОК 1: Вступ ===
    {
      id: 'viewer-welcome',
      target: '[data-tour="user-profile"]',
      title: '👋 Вітаємо, {displayName}!',
      description: 'Цей інтерактивний тур познайомить вас з переглядом аналітичних даних. Як глядач ви маєте доступ для перегляду всіх даних: проєктів, версій, макетів та подій. Ви можете бачити всю аналітику, але не можете створювати, редагувати або змінювати статуси подій.',
      position: 'bottom'
    },

    // === БЛОК 2: Додатки ===
    {
      id: 'viewer-apps-intro',
      target: '[data-tour="app-switcher"]',
      title: '📱 Розділ 1: Додатки',
      description: 'Ви маєте доступ до додатків, до яких вас запросили для перегляду аналітичних даних. Тут відображаються всі доступні додатки. Ви можете переглядати їх дані, але не створювати нові додатки або запрошувати учасників.',
      position: 'right'
    },

    // === БЛОК 3: Версії ===
    {
      id: 'viewer-version-selector',
      target: '[data-tour="version-selector"]',
      title: '📋 Список версій',
      description: 'Тут відображаються всі версії додатку. Активна версія підсвічена. Версія 2.0 позначена як "Поточна" та містить нові функції.',
      position: 'bottom'
    },
    {
      id: 'viewer-compare-versions',
      target: '[data-tour="compare-versions"]',
      title: '🔍 Порівняння версій',
      description: 'Ця кнопка відкриває режим порівняння двох версій. Ви можете побачити, які події додалися, видалилися або змінилися між версіями 1.0 та 2.0.',
      position: 'bottom'
    },

    // === БЛОК 4: Макети ===
    {
      id: 'viewer-screens-list',
      target: '[data-tour="screens-list"]',
      title: '📑 Список макетів',
      description: 'Тут відображаються всі макети поточної версії. Натисніть на макет, щоб відкрити його на канві та побачити події.',
      position: 'right'
    },

    // === БЛОК 5: Канва та події ===
    {
      id: 'viewer-canvas-area',
      target: '[data-tour="canvas"]',
      title: '🖱️ Робота з канвою',
      description: 'Використовуйте колесо миші для масштабування, перетягування для навігації. Подвійний клік скидає масштаб. Події відображаються як кольорові маркери на макеті.',
      position: 'center'
    },
    {
      id: 'viewer-event-markers',
      target: '[data-tour="event-marker"]',
      title: '📌 Маркери подій',
      description: 'Кожна подія відображається як маркер з номером. Колір маркера відповідає статусу події. Натисніть на маркер, щоб відкрити деталі події в правій панелі.',
      position: 'right',
      action: () => {
        const store = (window as any).__STORE__;
        if (store) {
          const state = store.getState();
          const currentScreen = state.currentScreen;
          if (currentScreen?.events?.length > 0) {
            store.getState().selectEvent(currentScreen?.events?.[0]?.id);
          }
        }
      }
    },
    // === БЛОК 6: Статуси подій ===
    {
      id: 'viewer-event-details',
      target: '[data-tour="event-details"]',
      title: '📝 Деталі події',
      description: 'Права панель показує деталі вибраної події: назву, опис, тип, статус, параметри та коментарі. Ви можете переглядати всю цю інформацію, але не редагувати її.',
      position: 'left'
    },
    {
      id: 'viewer-event-statuses',
      target: '[data-tour="status-filter"]',
      title: '🏷️ Статуси подій',
      description: 'Події мають 5 статусів, які показують їхній стан впровадження: 🟢 Нова - щойно створена; 🟡 Змінено - внесені правки; 🔵 Впроваджено - код в продакшені; 🔴 На видалення - застаріла; ⚪ Видалено - повністю видалена.',
      position: 'right',
      action: () => {
        window.dispatchEvent(new CustomEvent('tour-open-status-dropdown'));
      }
    },

    // === БЛОК 7: Типи подій, параметри, коментарі ===
    {
      id: 'viewer-event-types',
      target: '[data-tour="event-types"]',
      title: '📊 Типи подій',
      description: 'Події мають типи: View (перегляд), Click (клік), Input (введення), Success (успіх), Error (помилка), Custom (інше). Тип допомагає категоризувати події для аналізу.',
      position: 'left',
      action: () => {
        window.dispatchEvent(new CustomEvent('tour-close-status-dropdown'));
      }
    },
    {
      id: 'viewer-event-params',
      target: '[data-tour="event-params"]',
      title: '🔧 Параметри події',
      description: 'Кожна подія може мати параметри - додаткові дані, які передаються з подією. Наприклад, ID товару, ціна, тип дії. Параметри мають типи: string, number, boolean.',
      position: 'left'
    },
    {
      id: 'viewer-event-comments',
      target: '[data-tour="event-comments"]',
      title: '💬 Коментарі',
      description: 'Коментарі показують обговорення між аналітиками та розробниками. Ви можете переглядати всю історію комунікації щодо кожної події.',
      position: 'left'
    },

    // === БЛОК 8: Фільтри та пошук ===
    {
      id: 'viewer-filters',
      target: '[data-tour="filters"]',
      title: '⚡ Фільтри подій',
      description: 'Фільтруйте події за статусом та типом. Це допомагає зосередитися на конкретних подіях.',
      position: 'left'
    },
    {
      id: 'viewer-search',
      target: '[data-tour="search"]',
      title: '🔍 Пошук подій',
      description: 'Використовуйте пошук для знаходження подій за назвою. Пошук працює в реальному часі.',
      position: 'left'
    },

    // === БЛОК 9: Історія змін ===
    {
      id: 'viewer-history',
      target: '[data-tour="history-panel"]',
      title: '🕐 Історія змін',
      description: 'Панель історії показує всі зміни подій: створення, редагування, зміну статусів. Ви можете побачити хто, коли і що змінив.',
      position: 'left',
      action: () => {
        window.dispatchEvent(new CustomEvent('tour-open-history-panel'));
      }
    },

    // === БЛОК 10: Експорт даних ===
    {
      id: 'viewer-export',
      target: '[data-tour="export-panel"]',
      title: '📤 Експорт даних',
      description: 'Експортуйте всі події проєкту в форматі JSON або CSV для імпорту в Firebase Analytics або інші системи. Корисно для резервного копіювання або аналізу в інших інструментах.',
      position: 'bottom',
      action: () => {
        window.dispatchEvent(new CustomEvent('tour-close-history-panel'));
      }
    },

    // === БЛОК 11: Завершення ===
    {
      id: 'viewer-completion',
      target: '',
      title: '🎉 Вітаємо! Тур завершено',
      description: 'Ви ознайомились з можливостями перегляду даних! Тепер ви можете переглядати проєкти, версії, макети та події, аналізувати статуси впровадження та відстежувати прогрес розробки.',
      position: 'center'
    }
  ],

  demoData: {
    name: getDemoAppNameForRole('viewer'),
    description: DEMO_APP_DESCRIPTION,
    versions: demoVersions
  }
};

/**
 * Отримує демо-дані для Viewer з унікальними ID
 * Версії відсортовані: активна версія (2.0) йде першою
 * Использует реальные данные из экспорта JSON
 */
export function getViewerDemoData(userId: string): RoleOnboardingConfig['demoData'] {
  return createDemoDataForUser(userId, 'viewer');
}
